import { render } from "./RolesPermisos.vue?vue&type=template&id=3b4387b2"
import script from "./RolesPermisos.vue?vue&type=script&lang=js"
export * from "./RolesPermisos.vue?vue&type=script&lang=js"

import "./RolesPermisos.vue?vue&type=style&index=0&id=3b4387b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__